import * as React from "react";
import { BrandList as BrandList$1, BrandListGroup, BrandListItem } from "@grandvisionhq/content";
import { Heading } from "@grandvisionhq/elements";
import { useIntl } from "@grandvisionhq/state";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { groupBrands } from "../../../../utils/utils/group-brands.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
const CmsBrandListItem = withEditableContent(({ content }) => {
  const [link] = useBloomreachLinks([{ url: content.url ?? "#" }]);
  return /* @__PURE__ */ React.createElement(BrandListItem, { url: link.url }, content.title);
});
const CmsBrandList = ({ content, meta, template }) => {
  const { locale } = useIntl();
  switch (template) {
    case "brand-list":
      const groups = groupBrands(content.items, 4, locale);
      return /* @__PURE__ */ React.createElement(BrandList$1, { title: String(meta.title) }, groups.map(({ title, items }, i) => /* @__PURE__ */ React.createElement(BrandListGroup, { title, key: i }, items.map((brand) => /* @__PURE__ */ React.createElement(CmsBrandListItem, { content: brand, key: brand.id })))));
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "Banner of type ", template, " not defined in BrandList");
  }
};
const BrandList = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachPageable,
  withAnchor
)(CmsBrandList);
export {
  CmsBrandList,
  BrandList as default
};
//# sourceMappingURL=BrandList.js.map
